import React, { useState, useEffect } from 'react'
import { Table, Button, Space, Modal, Input, Select, notification, Tabs, Popover, Row, Col, Card, message, Upload } from 'antd'
import axios from 'axios';
import './Assesment.css'
import { AssesmentUrl, BaseUrl, ImageGenUrl, REACT_APP_ACESS_KEY_ID, REACT_APP_SECRET_ACESS_KEY, manualGenUrl } from '../../Constants/Constants';
import { EditOutlined, PlusCircleOutlined, SearchOutlined, UsergroupAddOutlined } from '@ant-design/icons';
import { InboxOutlined } from "@ant-design/icons";
import Dragger from "antd/es/upload/Dragger";
import AWS from 'aws-sdk'
import { Checkbox } from 'antd';
import ManualAssessmentModal from './ManualAssessment/ManualAssessmentModal';
const Assesment = () => {

    const s3 = new AWS.S3();

    const profileData = JSON.parse(localStorage.getItem('Profile'));
    const userEmail = profileData.email;

    const [api, contextHolder] = notification.useNotification();
    const [Data, setData] = useState([])
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [Loading, setLoading] = useState(false)
    const [showTable, setshowTable] = useState(false)
    const [CourseData, setCourseData] = useState([])
    const [Status, setStatus] = useState(true)
    const [NumberOfQuestions, setNumberOfQuestions] = useState('');
    const [assessmentName, setAssessmentName] = useState('');
    const [assessmentLevel, setAssessmentLevel] = useState(null);
    const [assessmentId, setAssessmentId] = useState('')


    const [trueOrFalseQuestions, setTrueOrFalseQuestions]= useState(0);
    const[ multipleAnswer, setMultipleAnswer]= useState("0");
    const[mcqQuestionsCount, setMcqQuestionsCount]= useState('0')
    const[matchingListQuestions, setMatchingListQuestions]=useState('0');
    const[fillBlankQuestions,setFillBlankQuestions]= useState('0')
    const[fillblankDescQuestions, setFillBlankDescQuestions]= useState('0');
    const[TableQuestions, setTableQuestions]= useState('0');
    const[ImageQuestions, setImageQuestions]= useState('0');
    const [Duration, setDuration] = useState('0')
    const [LoadTable, setLoadTable] = useState(false)
    const [SelectedCourseId, setSelectedCourseId] = useState(null)
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [EditAssessmentData, setEditAssessmentData] = useState(null);
    const [assessmentType, setAssessmentType] = useState('');
    const [assessmentTypeId, setAssessmentTypeId] = useState('');
    const [file, setfile] = useState([]);
    const [arrayFiles, setarrayFiles] = useState("");
    const [fileList, setFileList] = useState([]);
    const [BTNLoading, setBTNLoading] = useState(false);
    const [searchCourse, setSearchCourse] = useState('');
    const [statusFilter, setStatusFilter] = useState('Active');    // const [filteredData, setFilteredData] = useState(assessmentsData);
    const [filteredData1, setFilteredData1] = useState(Data);
    const [showInactive, setShowInactive] = useState(false);
    const [manualModalVisible, setManualModalVisible] = useState(false);
     const [clearTableData, setClearTableData] = useState([]);
     const [totalQuestions , setTotalQuestions] = useState([])



    AWS.config.update({
        region: 'us-east-1',
        credentials: new AWS.Credentials({
            accessKeyId: REACT_APP_ACESS_KEY_ID,
            secretAccessKey: REACT_APP_SECRET_ACESS_KEY,
            s3ForcePathStyle: true,
        }),
    });

    const companyId = localStorage.getItem('companyId');

    console.log(companyId, 'companyId')



    const columns = [

        {
            title: 'Action',
            key: 'action',
            render: (_, record) => (
                <Space size="middle">
                    <EditOutlined className='Edit' onClick={() => showEditModal(record)} />
                </Space>
            ),
        },

        {
            title: 'S.No',
            dataIndex: 'key',
            key: 'key',
        },

        {
            title: 'Course Name',
            dataIndex: 'course_title',
            key: 'course_title',
            render: (text, record) => <p
            // onClick={(e) => OpenTeamview(record)}
            // className='NameTxtTeam'
            >{text}</p>,
        },

        {
            title: 'Assessment Name',
            dataIndex: 'Assessment_name',
            key: 'Assessment_name',
            render: (text, record) => ( 
                <p
                    style={{ textTransform: 'capitalize' }}
                // onClick={(e) => OpenTeamview(record)}
                // className='NameTxtTeam'
                >{text}</p>),
            align: 'center'
        },

        {
            title: 'Assessment Level',
            dataIndex: 'Assessment_level',
            key: 'Assessment_level',
            render: (text, record) => <p
                // onClick={(e) => OpenTeamview(record)}
                // className='NameTxtTeam'
                style={{ textTransform: 'capitalize' }}
            >{text}</p>,
            align: 'center'
        },
        {
            title: 'Assessment Type',
            dataIndex: 'Assessment_type',
            key: 'Assessment_type',
            render: (text, record) => <p
                // onClick={(e) => OpenTeamview(record)}
                // className='NameTxtTeam'
                style={{ textTransform: 'capitalize' }}
            >{text === 'mcq' ? text.toUpperCase() : text === 'mcq with description' ? "MCQ with Description" : text} </p>,
            align: 'center'
        },
        {
            title: 'Question Count',
            dataIndex: 'Number_of_questions',
            key: 'Number_of_questions',
            align: 'center' 
        },
        ,
        {
            title: 'Duration',
            dataIndex: 'Assesment_Duration',
            key: 'Assesment_Duration',
            render: (text, record) => <p
            // onClick={(e) => OpenTeamview(record)}
            >{text}:00 mins</p>,
        },

        {
            title: 'Created Date and Time',
            dataIndex: 'created_at',
            key: 'created_at',
            render: (text, record) => {
                const date = new Date(text);

                const dateOptions = {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric'
                };

                const timeOptions = {
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: false // Set to true for 12-hour format with AM/PM
                };

                const formattedDate = date.toLocaleDateString('en-GB', dateOptions);
                const formattedTime = date.toLocaleTimeString('en-GB', timeOptions);

                return <p>{`${formattedDate} ${formattedTime}`}</p>;
            },

        },

    ];

    const levelOptions = [
        {
            value: 'easy',
            label: 'Easy'
        },
        {
            value: 'medium',
            label: 'Medium'
        },
        {
            value: 'hard',
            label: 'Hard'
        },
    ]

    const courseData = () => {
        axios
            .get(`${BaseUrl}courses/findAll`, {withCredentials:true})
            .then((res) => {
                console.log(res.data, "courseData")
                const transformnedArray = res.data.data.map(item => ({
                    value: item.course_id,
                    label: item.course_title
                }))
                console.log(transformnedArray, "transformnedArray")
                setCourseData(transformnedArray)
            })
            .catch((err) => {

            })
    }

    const openNotificationWithIconWarning = (type) => {
        api['warning']({
            message: "Warning!!!",
            description:
                type,
        });
    };
    const openNotificationWithIconError = (type) => {
        api['error']({
            message: "Oops!!!",
            description:
                type,
        });
    };
    const openNotificationWithIconSuccess = (type) => {
        console.log('getsSuccess')
        api['success']({
            message: "Success!!!",
            description:
                type,
        });
    };


    useEffect(() => {
        TableData()
        courseData()
    }, [LoadTable])

    const TableData = () => {
        setLoading(true)
        axios
            .get(`${BaseUrl}assesment`, {withCredentials:true})
            .then((res) => {
              

                const transformedData = res.data.map((item) => {
                    return ({
                        Assesment_status: item.status,
                        Number_of_questions: item.Number_of_questions,
                        key: item.key,
                        course_title: item.course_id.course_title,
                        Assesment_id: item.Assesment_id,
                        Assesment_Duration: item.Assesment_Duration,
                        created_at: item.created_at,
                        Assessment_name: item.Assessment_name,
                        Assessment_level: item.Assessment_level,
                        Assessment_type: item.assessment_type,
                        Assessment_type_id: item.assessment_type_id

                    })
                }
                );

                setData(transformedData)
                setLoading(false)
            })
    }

  

    const showEditModal = (record) => {
        console.log(record, 'editModalRecord')
        setIsEditModalOpen(true);
        setEditAssessmentData(record);
        setAssessmentName(record.Assessment_name);
        setAssessmentLevel(record.Assessment_level);
        setSelectedCourseId(record.course_id);
        setNumberOfQuestions(record.Number_of_questions);
        setDuration(record.Assesment_Duration);
        setAssessmentId(record.Assesment_id);
        setStatus(record.Assesment_status);
    };

    const handleEditOk = () => {
        // Update the assessment with the edited data
        // You can use the EditAssessmentData state to get the edited data
        // Perform necessary actions (e.g., API calls) to update the assessment
        // Close the modal and perform any other necessary operations

        let body = {
            Assesment_id: assessmentId,
            Number_of_questions: NumberOfQuestions,
            Assesment_Duration: Duration,
            Assessment_name: assessmentName,
            Assessment_level: assessmentLevel,
            status: Status,
            // assessment_type : assessmentType,
            // assessment_type_id : assessmentTypeId,
            // assessment_object : {
            //     "key1": "value1",
            //     "key2": "value2"
            // }
        }

        axios.post(`${BaseUrl}assesment/assessment_update`, body, {withCredentials:true})
            .then((res) => {
                console.log(res, 'updateResponse');

                if (res.data.statuscode === 200) {
                    setLoadTable(!LoadTable);
                    openNotificationWithIconSuccess('Updated successfully!');
                    setIsEditModalOpen(false);
                } else {
                    openNotificationWithIconError('Error Updating');
                    setIsEditModalOpen(false);
                }

            })

            .catch((err) => {
                openNotificationWithIconError('Error Updating');
                setIsEditModalOpen(false);
            })




    };

   



    useEffect(() => {
        if (searchCourse === '') { setClearTableData(Data); return; }

        const filteredEmails = Data.filter((item) => item.course_title.toLowerCase().includes(searchCourse.toLowerCase()))
        setClearTableData(filteredEmails);
        console.log(Data, 'searchVal')

    }, [searchCourse, Data])


    const handleEditCancel = () => {
        // Close the modal without saving any changes
        setIsEditModalOpen(false);
    };


    // const showModal = (e, id) => {
    //     console.log(id, "showModal");
    //     setAssessmentType(e);
    //     setAssessmentTypeId(id);
    //     setAssessmentLevel(null);
    //     setAssessmentName('');
    //     setNumberOfQuestions('');
    //     setDuration('');
    //     setSelectedCourseId(null);
    //     setIsModalOpen(true);

    // };

const showModal = (e, id) => {
    
    // Special handling for manual assessment
    if (e === 'manual') {
        setManualModalVisible(true);
        return; // Exit early for manual
    }
    
    // Existing logic for other types (MCQ, Image, etc.)
    setAssessmentType(e);
    setAssessmentTypeId(id);
    setAssessmentLevel(null);
    setAssessmentName('');
    setNumberOfQuestions('');
    setDuration('');
    setSelectedCourseId(null);
    setIsModalOpen(true);
};

const handleManualSuccess = () => {
    setManualModalVisible(false);
    setLoadTable(!LoadTable); // Refresh the table
};
    const handleOk = () => {
        if (assessmentName === '' || assessmentLevel === null || SelectedCourseId === null || Duration === '') {
            openNotificationWithIconWarning('Please fill all the fields to submit')
        } else {
            setBTNLoading(true)

            if (assessmentType === 'mcq') {
                let body = {
                    // companyid: "b741fee7-80cb-4422-82e6-c0df5bcb288f",
                    course_id: SelectedCourseId,
                    Number_of_questions: NumberOfQuestions,
                    Assesment_Duration: Duration,
                    Assessment_name: assessmentName,  
                    Assessment_level: assessmentLevel,
                    status: Status,
                    assessment_type: assessmentType,
                    assessment_type_id: assessmentTypeId,
                    assessment_object: ''
                }
                axios
                    .post(`${BaseUrl}assesment/add`, body, {withCredentials:true})
                    .then((res) => {
                        if (res.data.statuscode === 200) {
                            let assessmentId = res.data.data[0].Assesment_id;

                            let Body = {

                                course_id: SelectedCourseId,
                                no_of_questions: NumberOfQuestions,
                                assessment_id: assessmentId,
                                mailid: userEmail,
                                mcq:mcqQuestionsCount,
                                tf: trueOrFalseQuestions,
                                multiple_answer: multipleAnswer,
                                matching_list: matchingListQuestions,
                                fill_blank: fillBlankQuestions,
                                fill_blank_desc: fillblankDescQuestions,
                                table_q: TableQuestions,
                                m_img: ImageQuestions,

                            }

                            
                            axios
                                .post(`${AssesmentUrl}mcq_generation`, Body)
                                .then((res) => {
                                    console.log(res, 'mcqGenerationResp');
                                    if (res.data.status == 200) {
                                        openNotificationWithIconSuccess('Assessment Assigned Sucessfully !')
                                        setLoadTable(true)
                                        setLoading(false);
                                        setBTNLoading(false)
                                        setTotalQuestions([]);
                                        setIsModalOpen(false);
                                    }
                                })
                                
                                .catch((err) => {
                                    console.log(err, "err");
                                    openNotificationWithIconWarning('Error generating questions!')
                                    setBTNLoading(false)
                                })

                        } else {
                            openNotificationWithIconError(`Can't create assessment!`)
                        }
                    })
                    .catch((err) => {
                        console.log(err)
                        setIsModalOpen(false);
                        setLoading(false)
                        setBTNLoading(false)
                        openNotificationWithIconWarning("Can't create assessment!")
                    })

                // let Body = {
                //     course_id: SelectedCourseId,
                //     no_of_questions: NumberOfQuestions,
                //     assessment_id : 
                // }
                // axios
                //     .post(`${AssesmentUrl}mcq_generation`, Body)
                //     .then((res) => {
                //         console.log(res)
                //     })
                //     .catch((err) => {
                //         console.log(err, "err");
                //         openNotificationWithIconWarning('Error generating questions!')
                //         setBTNLoading(false)
                //     })

            }
            else if (assessmentType === 'mcq with description') {
                let body = {
                    // companyid: companyId,
                    course_id: SelectedCourseId,
                    Number_of_questions: NumberOfQuestions,
                    Assesment_Duration: Duration,
                    Assessment_name: assessmentName,
                    Assessment_level: assessmentLevel,
                    status: Status,
                    assessment_type: assessmentType,
                    assessment_type_id: assessmentTypeId,
                    assessment_object: ''
                }
                axios
                    .post(`${BaseUrl}assesment/add`, body, {withCredentials:true})
                    .then((res) => {
                        console.log(res.data, 'mcqGeneratedResponse')
                        if (res.data.statuscode === 200) {
                            let assessmentId = res.data.data[0].Assesment_id;

                            let Body = {
                                course_id: SelectedCourseId,
                                no_of_questions: NumberOfQuestions,
                                assessment_id: assessmentId,
                                mailid: userEmail
                            }
                            axios
                                .post(`${AssesmentUrl}mcq_generation`, Body)
                                .then((res) => {
                                    console.log(res, 'mcqGenerationResp');
                                    if (res.data.status == 200) {
                                        openNotificationWithIconSuccess('Assessment Assigned Sucessfully !')
                                        setLoadTable(true)
                                        setLoading(false);
                                        setBTNLoading(false)
                                        setTotalQuestions([]);
                                        setIsModalOpen(false);
                                    }
                                })
                                .catch((err) => {
                                    console.log(err, "err");
                                    openNotificationWithIconWarning('Error generating questions!')
                                    setBTNLoading(false)
                                })

                        } else {
                            openNotificationWithIconError(`Can't create assessment!`)
                        }
                    })
                    .catch((err) => {
                        console.log(err)
                        setIsModalOpen(false);
                        setLoading(false)
                        setBTNLoading(false)
                        openNotificationWithIconWarning("Can't create assessment!")
                    })

                // let Body = {
                //     course_id: SelectedCourseId,
                //     no_of_questions: NumberOfQuestions,
                //     assessment_id : 
                // }
                // axios
                //     .post(`${AssesmentUrl}mcq_generation`, Body)
                //     .then((res) => {
                //         console.log(res)
                //     })
                //     .catch((err) => {
                //         console.log(err, "err");
                //         openNotificationWithIconWarning('Error generating questions!')
                //         setBTNLoading(false)
                //     })

            }
            else if (assessmentType === 'image') {
                if (file.length < 10) {
                    openNotificationWithIconWarning('Upload at least 10 images to submit!');
                    setBTNLoading(false);
                    return;
                }

                setLoading(true);

                // Generate file URLs (replace spaces with '+')
                const fileUrls = file.map((i) => {
                    const url = `https://trainingnexus-images.s3.amazonaws.com/Assessment/${SelectedCourseId}/${assessmentName}/${i.name}`;
                    return url.replace(/\s+/g, '+');
                });

                // Prepare request body for `assesment/add` API
                const assessmentData = {
                    Number_of_questions: file.length.toString(),
                    Assesment_Duration: Duration,
                    // companyid: "b741fee7-80cb-4422-82e6-c0df5bcb288f",
                    course_id: SelectedCourseId,
                    Assessment_name: assessmentName,
                    Assessment_level: assessmentLevel,
                    status: Status,
                    assessment_type: assessmentType,
                    assessment_type_id: assessmentTypeId,
                    assessment_object: JSON.stringify(fileUrls), // Send as string
                };

                axios.post(`${BaseUrl}assesment/add`, assessmentData, {
                    headers: { "Content-Type": "application/json" },
                    withCredentials:true
                })
                    .then((res) => {
                        console.log(res.data, 'assessmentImageResponse');

                        if (res.data.statuscode === 200) {
                            console.log('Reached Here');
                            const resAssessmentId = res.data.data[0].Assesment_id; // Assuming saved assessment ID is returned

                            // Prepare FormData for `generate_image_questions` API
                            let imageFormData = new FormData();
                            imageFormData.append("assesment_id", resAssessmentId);
                            imageFormData.append("course_id", SelectedCourseId);
                            imageFormData.append("no_of_question", file.length.toString());

                            file.forEach((fileItem) => {
                                imageFormData.append("image_files", fileItem);
                            });

                            axios.post(`${AssesmentUrl}generate_image_questions`, imageFormData, {
                                headers: { "Content-Type": "multipart/form-data" },
                                withCredentials:true
                            })
                                .then((res) => {
                                    console.log(res, 'generateQuestionResponse');

                                    if (res.data.status === 200) {
                                        openNotificationWithIconSuccess('Assessment Assigned Successfully!');
                                        setLoadTable(true);
                                        setLoading(false);
                                        setBTNLoading(false);
                                        setIsModalOpen(false);
                                        setfile([]);
                                        setFileList([]);
                                    }
                                })
                                .catch((err) => {
                                    console.log(err, 'GenerateImageQuestionError');
                                    openNotificationWithIconError('Error Uploading images!');
                                    setIsModalOpen(false);
                                    setBTNLoading(false);
                                });

                        } else {
                            openNotificationWithIconError('Error Uploading assessment!');
                        }
                    })
                    .catch((err) => {
                        console.log(err, 'errMessage');
                        setIsModalOpen(false);
                        setLoading(false);
                        openNotificationWithIconWarning("Error");
                    });
            }

        }

    };

    console.log(file, 'draggerFile')
    const handleCancel = () => {
    setIsModalOpen(false);
    setBTNLoading(false);
    setAssessmentName('');
    setAssessmentLevel('');
    setSelectedCourseId('');
    setNumberOfQuestions('');
    setAssessmentType('');
    setDuration('');
    setStatus(true);
    setfile([]);
    setFileList([]);
};
    const handleChange = (value) => {
        setStatus(value)
    }


    const assessmentPopContent = (
        <div>
            <p onClick={() => showModal('mcq', 1)} className='assessmentTypes'>AI generated MCQ</p>
            <p onClick={() => showModal('image', 2)} className='assessmentTypes'>AI generated Image</p>
            <p onClick={() => showModal('manual', 3)} className='assessmentTypes'>Manual Questions</p>
            <p onClick={() => showModal('mcq with description', 4)} className='assessmentTypes'>AI generated MCQ with Description</p>
        </div>
    );


    // Filter data based on the statusFilter
    const filteredData = clearTableData.filter(item =>
        showInactive ? item.Assesment_status === false : item.Assesment_status === true
    );
    console.log("Filtered Data:", filteredData);


    const handleSwitchChange = (checked) => {
        setStatusFilter(checked ? 'Active' : 'Inactive');
    };

    const handleCheckboxChange = (e) => {
        setShowInactive(e.target.checked);
    };

    return (
        <div className='Assesment_main'>
            {contextHolder}
             <ManualAssessmentModal
            visible={manualModalVisible}
            onCancel={() => setManualModalVisible(false)}
            CourseData={CourseData}
            onSuccess={handleManualSuccess}
        />

            <Modal title="Edit Assessment"
                open={isEditModalOpen}
                onOk={handleEditOk}
                onCancel={handleEditCancel}>

                <p style={{ marginTop: 20 }} className='Title' >Assessment Name</p>
                <Input placeholder="Assessment Name"
                    value={assessmentName}

                    onChange={(e) => setAssessmentName(e.target.value)}
                    className='EditInput' />

                <p className='Title' >Select Assessment Level</p>
                <Select
                    value={assessmentLevel}
                    placeholder="Select Level"
                    className='EditInput'
                    onChange={(value) => setAssessmentLevel(value)}
                    options={levelOptions}
                />

                <p className='Title' >Number of questions</p>
                <Input placeholder="Number of questions"
                    // value={UserName}
                    value={NumberOfQuestions}

                    onChange={(e) => setNumberOfQuestions(e.target.value)}
                    className='EditInput' />
                <p className='Title' >Assessment Duration</p>
                <Input placeholder="Assessment Duration"
                    value={Duration}
                    onChange={(e) => setDuration(e.target.value)}

                    className='EditInput' />

                <p className='Title' >Status</p>
                <Select
                    // defaultValue="Active"
                    value={Status}
                    className='EditInput'
                    onChange={handleChange}
                    options={[
                        {
                            value: true,
                            label: 'Active',
                        },
                        {
                            value: false,
                            label: 'Inactive',
                        }
                    ]}
                />



            </Modal>
            <Modal className={assessmentType === 'mcq' && 'mcq with description' ? 'addAssessmentMcqModalClass' : 'addAssessmentModalClass'}
                title={<p style={{ marginBottom: 0 }}>Add Assessment - <span className='assessmentTypeClass'>{assessmentType}</span></p>}
                open={isModalOpen}
                footer={false}
                // onOk={handleOk}
                onCancel={handleCancel}
            >
                {assessmentType == "image" &&
                    <p style={{ marginBottom: 0 }} className='ant-upload-hint'>
                        Note: (Please upload a minimum of 10 images to proceed with the creation of the image assessment.)
                    </p>
                }
                <Row>
                    <Col span={assessmentType === 'mcq' && 'mcq with description' ? 24 : 9}>
                        <h3>Fill in the details</h3>

                        <p style={{ marginTop: 20 }} className='Title' >Assessment Name</p>
                        <Input placeholder="Assessment Name"
                            value={assessmentName}

                            onChange={(e) => setAssessmentName(e.target.value)}
                            className='EditInput' />

                        <p className='Title' >Select Assessment Level</p>
                        <Select
                            value={assessmentLevel}
                            placeholder="Select Level"
                            className='EditInput'
                            onChange={(value) => setAssessmentLevel(value)}
                            options={levelOptions}
                        />

                        <p className='Title' >Select Course</p>
                        <Select
                            value={SelectedCourseId}
                            placeholder="Select Course"
                            className='EditInput'
                            onChange={(value) => setSelectedCourseId(value)}
                            options={CourseData}
                        />
                        {
                            assessmentType === 'mcq' ?
                                <>
                                    <p className='Title' >Question Count</p>
                                    <Input placeholder="Number of questions"
                                        value={NumberOfQuestions}

                                        onChange={(e) => setNumberOfQuestions(e.target.value)}
                                        className='EditInput' />
                                </>
                                :
                                <></>
                        }
                         {
                            assessmentType === 'mcq' ?
                                <>
                                    <p className='Title' >Mcq count</p>
                                    <Input placeholder="Number of questions"
                                        value={mcqQuestionsCount}

                                        onChange={(e) => setMcqQuestionsCount(e.target.value)}
                                        className='EditInput' />
                                </>
                                :
                                <></>
                        }


{
                            assessmentType === 'mcq' ?
                                <>
                                    <p className='Title' >True Or False Questions</p>
                                    <Input placeholder="Number of questions"
                                        value={trueOrFalseQuestions}

                                        onChange={(e) => setTrueOrFalseQuestions(e.target.value)}
                                        className='EditInput' />
                                </>
                                :
                                <></>
                        }
                         {
                            assessmentType === 'mcq' ?
                                <>
                                    <p className='Title' >Multiple Answer Questions</p>
                                    <Input placeholder="Number of questions"
                                        value={multipleAnswer}

                                        onChange={(e) => setMultipleAnswer(e.target.value)}
                                        className='EditInput' />
                                </>
                                :
                                <></>
                        }
                         {
                            assessmentType === 'mcq' ?
                                <>
                                    <p className='Title' >Matching List</p>
                                    <Input placeholder="Number of questions"
                                        value={matchingListQuestions}

                                        onChange={(e) => setMatchingListQuestions(e.target.value)}
                                        className='EditInput' />
                                </>
                                :
                                <></>
                        }
                         {
                            assessmentType === 'mcq' ?
                                <>
                                    <p className='Title' >Fill In The Blank</p>
                                    <Input placeholder="Number of questions"
                                        value={fillBlankQuestions}

                                        onChange={(e) => setFillBlankQuestions(e.target.value)}
                                        className='EditInput' />
                                </>
                                :
                                <></>
                        }
                         {
                            assessmentType === 'mcq' ?
                                <>
                                    <p className='Title' >Fill Blank Description</p>
                                    <Input placeholder="Number of questions"
                                        value={fillblankDescQuestions}

                                        onChange={(e) => setFillBlankDescQuestions(e.target.value)}
                                        className='EditInput' />
                                </>
                                :
                                <></>
                        }
                         {
                            assessmentType === 'mcq' ?
                                <>
                                    <p className='Title' > Table Question Count</p>
                                    <Input placeholder="Number of questions"
                                        value={TableQuestions}

                                        onChange={(e) => setTableQuestions(e.target.value)}
                                        className='EditInput' />
                                </>
                                :
                                <></>
                        }
                          {
                            assessmentType === 'mcq' ?
                                <>
                                    <p className='Title' > Image Question Count</p>
                                    <Input placeholder="Number of questions"
                                        value={ImageQuestions}

                                        onChange={(e) => setImageQuestions(e.target.value)}
                                        className='EditInput' />
                                </>
                                :
                                <></>
                        }
                        {/* "mcq": 0,
  "tf": 0,
  "multiple_answer": 0,
  "matching_list": 0,
  "fill_blank": 0,
  "fill_blank_desc": 0,
  "table_q": 0,
  "image": 0 */}
                        {
                            assessmentType === 'mcq with description' ?
                                <>
                                    <p className='Title' >Question Count</p>
                                    <Input placeholder="Number of questions"
                                        value={NumberOfQuestions}

                                        onChange={(e) => setNumberOfQuestions(e.target.value)}
                                        className='EditInput' />
                                </>
                                :
                                <></>
                        }

                        <p className='Title' >Assessment Duration</p>
                        <Input placeholder="Assessment Duration"
                            onChange={(e) => setDuration(e.target.value)}
                            value={Duration}
                            className='EditInput' />

                        <p className='Title' >Status</p>
                        <Select
                            defaultValue={true}
                            className='EditInput'
                            value={Status}
                            onChange={handleChange}
                            options={[
                                {
                                    value: true,
                                    label: 'Active',
                                },
                                {
                                    value: false,
                                    label: 'Inactive',
                                }
                            ]}
                        />
                    </Col>
                    {
                        assessmentType === 'image' ?
                            <>
                                <Col span={14} offset={1} >
                                    <h3>Upload/Drag images to genreate questions</h3>
                                    <p className='Title' >Upload Image</p>
                                    <Dragger
                                        fileList={fileList}
                                        multiple={true}
                                        className='imageUploader'
                                        customRequest={({ file, onSuccess, onError }) => {
                                            const isImage = file.type.startsWith('image/');
                                            const isSVG = file.type === 'image/svg+xml';
                                            if (!isImage || isSVG) {
                                                openNotificationWithIconError("Only image without SVG formats are allowed.");
                                                setBTNLoading(false);
                                                return onError("Invalid file type");
                                            }
                                            onSuccess("ok")
                                        }}
                                        onChange={(info) => {

                                            const filteredList = info.fileList.filter(file => {
                                                const isImage = file.type.startsWith('image/');
                                                const isSVG = file.type === 'image/svg+xml';
                                                return isImage && !isSVG;
                                            });

                                            console.log(info, "info");
                                            setFileList(filteredList);
                                            const fileObj = filteredList.map((item) => item.originFileObj);
                                            setfile(fileObj)
                                        }}
                                    >
                                        <p className='ant-upload-drag-icon'>
                                            <InboxOutlined />

                                        </p>
                                        <p className='ant-upload-text'>
                                            Click or drag Image to this area to upload
                                        </p>
                                        <p className='ant-upload-hint'>
                                            (Supported formats - png, jpg, webp)
                                        </p>
                                    </Dragger>
                                </Col>
                            </>
                            :
                            <></>
                    }
                </Row>
                <Row className='footer-modal'>
                    <Button onClick={handleCancel} style={{ border: "1px solid black", marginRight: 20 }} type='secondary'>
                        Cancel
                    </Button>
                    <Button onClick={handleOk} loading={BTNLoading} type='primary'>
                        Submit
                    </Button>





                </Row>

            </Modal>
            <h2>
                Assessments
            </h2>
            <div className="switch-container">
                <Checkbox
                    checked={showInactive}
                    onChange={handleCheckboxChange}
                >
                    Show Inactive Assessment
                </Checkbox>
            </div>
            <br></br>
            <Row>
                <Col span={8} offset={10}>
                    <Input placeholder='Search by course name' className='searchInput'
                        onChange={(e) => setSearchCourse(e.target.value)}
                    />
                    <SearchOutlined className='inputSearch' />
                </Col>
                <Col offset={1} span={4}>
                    <Popover title='Select assessment type' placement='bottomRight'
                        content={assessmentPopContent}
                        trigger="hover"
                    >
                        <Button
                            // onClick={showModal}
                            className='ADD'
                            type='primary'
                        >
                            Add New Assessment<UsergroupAddOutlined />
                        </Button>
                    </Popover>
                </Col>
            </Row>



            {
                Loading ?
                    <div className='Loader' >

                        <img src='Loader\Ellipsis-2.9s-200px.svg'>
                        </img>
                    </div>
                    :
                    <Table
                        pagination={{
                            position: ['bottomCenter'],
                            showSizeChanger: false,
                        }} className='assessmentTable' columns={columns} dataSource={filteredData} />

            }</div>
    )
}

export default Assesment